import { render, staticRenderFns } from "./remarkPopTable.vue?vue&type=template&id=0d253b37"
import script from "./remarkPopTable.vue?vue&type=script&lang=js"
export * from "./remarkPopTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports